import React from "react";
import Media from "react-media";

export default ({ mobile, desktop }) =>
  <Media query="(max-width: 959px)">
    {matches =>
      matches
        ? //Mobile component
        <div>
          {mobile}
        </div>
        : //Desktop component
        <div>
          {desktop}
        </div>}
  </Media>;



// WEBPACK FOOTER //
// ./src/components/layout/LayoutSwitcher.js